import styled, { keyframes } from 'styled-components';

const EaseIn = keyframes`
  from{ opacity:0; }
  to{ opacity:1; }
`;

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
    margin-top: 52px;
  }

  .TitleContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media only screen and (max-width: 768px) {
      justify-content: center;
      align-self: center;
      align-items: center;
      margin-top: -20px;
    }
  }

  .CardContainer1 {
    margin-top: 20px;

    @media only screen and (max-width: 1092px) {
      margin-top: 30px;
    }

    @media only screen and (max-width: 983px) {
      margin-top: 100px;
    }

    @media only screen and (max-width: 880px) {
      margin-top: 100px;
    }

    @media only screen and (max-width: 768px) {
      margin-top: 120px;
    }

    @media only screen and (max-width: 568px) {
      margin-top: 220px;
    }

    .infoitem {
      @media only screen and (max-width: 1092px) {
        margin-top: 90px;
      }
      @media only screen and (max-width: 767px) {
        margin-top: 20px;
      }
    }
  }

  .CardContainer {
    margin-top: 20px;
    .infoitem {
      @media only screen and (max-width: 767px) {
        margin-top: 20px;
      }
    }
  }

  .buttonsContainer {
    margin-top: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      width: 50%;
      z-index: 9999999;
      margin-bottom: 31px;
    }
  }

  .buttons {
    display: flex;
    button {
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;

      &:hover {
        background: #b14729;
      }
    }
  }

  .tarifaOptions {
    transition: all 0.3s ease;
    animation: ${EaseIn} 0.5s;
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;
  color: var(--orange);
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    text-align: center;
    flex-direction: column-reverse;
  }
`;

export const SubTitle = styled.p`
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;

  color: #000000;
  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const Card = styled.div`
  display: flex;
  background: #ebf1f4;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 24px;
  padding: 35px;

  @media only screen and (max-width: 1092px) {
    margin-top: 30px;
    flex-direction: column;
  }

  @media only screen and (max-width: 884px) {
    margin-top: 90px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 90px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 40px;
  }

  .CardTitle {
    width: 18%;
    font-family: Roboto Slab;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 37px;
    color: #452359;
    @media only screen and (max-width: 767px) {
      width: 100%;
    }
  }

  .CardForm {
    width: 100%;
  }
`;
